import Ngql from 'gql/ninegql'

import { i18Key } from 'utils'
import conf from 'conf'

const serverURL =new URL(conf.SERVER.URL);

const defaultJson = `
{
  "AppEnterpriseServerAddr": "${serverURL.origin}",
  "AppServiceHosts": "",
  "AppEmailServiceProvider": "Exchange",
  "AppAuthenticationMethod": "Modern",
  "AppServiceUseSSL": true,
  "AppServicePort": 443,
  "AppServiceTransmissionProtocol": 0,
  "BrandingName": "",
  "BrandingLogo": "",
  "BrandingLogoForDark": "",
  "BrandingSplashLogo": "",
  "BrandingSplashColor": "",
  "UserFontFamily": "Calibri, Arial, Helvetica, sans-serif",
  "UserFontSize": 12,
  "UsreFontColor": "#000000",
  "UserReplyFontColor": "#1f497d",
  "UserSignature": "",
  "AllowMultipleAccounts": false,
  "AllowEmailSync": true,
  "AllowCalendarSync": true,
  "AllowContactsSync": true,
  "AllowTasksSync": true,
  "AllowNotesSync": true,
  "AllowShareAttachment": true,
  "AllowSaveAttachment": true,
  "AllowShareContents": true,
  "AllowCopyPaste": true,
  "AllowScreenShot": true
}
`;

const AppConfigNodeField = {
  id: true,
  name: Ngql.Field(true, null, {
    mode: 'all',
    labelKey: i18Key('appConfig.field.name'),
    type: 'text',
    config: {
      rules: [
        {
          required: true,
          messageKey: i18Key('appConfig.validation.name.empty'),
        },
      ],
    },
  }),
  config: Ngql.Field(true, null, {
    mode: 'none', // 'all',
    labelKey: i18Key('appConfig.field.config'),
    type: 'json',
    // default: null,
    inputAttrs: {
      style: {height: '424px'},
      rows: 20,
      // options: { schema: jsonSchema }
    },
    default: defaultJson,
    config: {
      rules: [
        {
          required: false,
          messageKey: i18Key('appConfig.validation.config.empty'),
        },
        {
          validate: true,
          messageKey: i18Key('appConfig.validation.config.invalidJson'),
        },
      ],
    },
  }),
  preset: Ngql.Field(true, null, {
    mode: 'readonly',
    labelKey: i18Key('appConfig.field.preset'),
    type: 'checkbox',
  }),
  createdAt: Ngql.Field(true, null, {
    mode: 'readonly',
    labelKey: i18Key('appConfig.field.createdAt'),
    type: 'datetime',
  }),
  updatedAt: Ngql.Field(true, null, {
    mode: 'readonly',
    labelKey: i18Key('appConfig.field.updatedAt'),
    type: 'datetime',
  }),
}

const AppConfigNode = Ngql.Node(AppConfigNodeField)

const queryAppConfigList = Ngql.Query('appConfigList', {
  allAppconfigs: Ngql.NodeConnection(AppConfigNode, {
    // sort: Ngql.Var('sort', '[AppconfigNodeSortEnum]'),
    pageNum: Ngql.Var('pageNum', 'Int'),
    pageSize: Ngql.Var('pageSize', 'Int'),
    filters: Ngql.Var('filters', 'AppconfigFilter'),
  }),
})

const queryAppConfigInfo = Ngql.Query('appConfigInfo', {
  allAppconfigs: Ngql.NodeConnection(AppConfigNode, {
    filters: Ngql.Var('filters', 'AppconfigFilter'),
  }),
})

const mutationCreateAppConfig = Ngql.Mutation('createAppConfig', {
  createAppconfig: Ngql.Node(
    {
      appconfig: AppConfigNode,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      appconfigData: Ngql.Var('appconfigData', 'AppconfigInput'),
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const mutationUpdateAppConfig = Ngql.Mutation('updateAppConfig', {
  updateAppconfig: Ngql.Node(
    {
      appconfig: AppConfigNode,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      appconfigData: Ngql.Var('appconfigData', 'AppconfigInput!'),
      appconfigGid: Ngql.Var('appconfigGid', 'String!'),
    },
  ),
})

const appConfigNodeArray = Ngql.Node(AppConfigNodeField, null, false, null, true)

const mutationDeleteAppConfig = Ngql.Mutation('deleteAppConfig', {
  deleteAppconfig: Ngql.Node(
    {
      results: appConfigNodeArray,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      appconfigGids: Ngql.Var('appconfigGids', '[String!]'),
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const userdeviceQueries = {
  AppConfigNodeField,
  queryAppConfigList,
  queryAppConfigInfo,
  mutationCreateAppConfig,
  mutationUpdateAppConfig,
  mutationDeleteAppConfig,
}

export default userdeviceQueries
